module.exports = __webpack_public_path__ + "static/media/Taxi.21202fbf.svg";